import * as DepositeModels from '../../models/deposite/deposite';
import { DepositeSearchModel } from '../../models/deposite/depositeSearch';
import { DepositeInventoryNoteSearchModel } from '../../models/deposite/depositeInventoryNoteSearch';
import * as Models from '../../models/commonModels';
import * as OrderModels from '../../models/order/order';

export class GetDepositeList {
  static readonly type = '[Deposite] Deposite List';
  constructor(public Search: DepositeSearchModel) { }
}

export class GetDepositePreviewList {
  static readonly type = '[Deposite] Deposite Preview List';
  constructor(public Search: DepositeSearchModel) { }
}

export class SetDeposite {
  static readonly type = '[Deposite] Set';
  constructor(public Deposite: Models.Request<DepositeModels.DepositeModel>) { }
}

export class SetInventory {
  static readonly type = '[Deposite] Set Inventory';
  constructor(public Deposite: Models.Request<DepositeModels.DepositeModel>) { }
}

export class SetDepositeList {
  static readonly type = '[Deposite] Set List';
  constructor(public Deposites: Models.RequestNewOrder<DepositeModels.DepositePreviewModel[]> ) { }
}

export class GetDepositeReport {
  static readonly type = '[Deposite] Report';
  constructor(public Search: DepositeSearchModel) { }
}

export class GetDepositeAgregatedReport {
  static readonly type = '[Deposite] Agregated Report';
  constructor(public Search: DepositeSearchModel) { }
}
export class GetDepositeAgregatedExtendedReport {
  static readonly type = '[Deposite] Agregated Report Extended';
  constructor(public Search: DepositeSearchModel) { }
}

export class GetDepositeUtilizationReport {
  static readonly type = '[Deposite] UtilizationReport';
  constructor(public Search: DepositeSearchModel) { }
}

export class GetDepositeInventoryNote {
  static readonly type = '[Deposite] DepositeInventoryNote';
  constructor(public Search: DepositeInventoryNoteSearchModel) {}
}

export class GetDepositeInventoryStatuses {
  static readonly type = '[Deposite]  DepositeInventoryStatuses';
  constructor() { }
}

export class SetDepositeSearch {
  static readonly type = '[Deposite]  Set Search';
  constructor(public Search: DepositeSearchModel) { }
}

export class ResetDepositeSearch {
  static readonly type = '[Deposite] Reset Search';
  constructor() { }
}

export class SetDepositeListPage {
  static readonly type = '[Deposite] Set Page';
  constructor(public Search: DepositeSearchModel) { }
}


export class GetDepositePdf {
  static readonly type = '[Deposite] GetDepositePdf';
  constructor(public Search: DepositeSearchModel) { }
}

export class ImportAgregatedExtended {
  static readonly type = '[Deposite] Import Agregaded Extended ';
  constructor(public FileName: string, public Data: any) { }
}

// this action state is responsible for clear the upload form,
export class SetImportAgregatedExtendedStatus {
  static readonly type = '[Deposite] ImportAgregatedExtended';
  constructor(public Status: boolean) { }
}

export class Get {
  static readonly type = '[Deposite] Get';
  constructor(public Id: Models.RequestModel) { }
}

export class ResetInventory {
  static readonly type = '[Deposite] Reset Inventory';
  constructor(public Deposite: Models.Request<DepositeModels.DepositeModel>) { }
}

export class SetInventoryList {
  static readonly type = '[Deposite] Set Inventory List';
  constructor(public Search: DepositeSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[Deposit] DisposeSearch';
  constructor() { }
}

export class SetMarkList {
  static readonly type = '[Deposit] SetMarkList';
  constructor(public RegistrationNumbers: string[]) { }
}

export class GetDepositeInventoryReport {
  static readonly type = '[Deposite] Report Inventory';
  constructor(public Search: DepositeSearchModel) { }
}

export class SetPickupCalls {
  static readonly type = '[Deposite] SetPickupCalls';
  constructor(public Request: Models.ContextRequest<OrderModels.OrderPreviewModel[], Date>) { }
}
